@if (variant === 'link') {
<a class="hyperlink" [href]="link" (keyup)="onKeyUpLink($event)">
  <span>{{ text }}</span>
  @if(icon){
  <span class="icon">
    {{ icon }}
  </span>
  }
</a>

} @if(variant === 'button'){
<a class="hyperlink white" (click)="clickLinkEvent()" (keyup)="onKeyUpLink($event)">
  <span>{{ text }}</span>
  @if(icon){
  <span class="icon">
    {{ icon }}
  </span>
  }
</a>
}
